import { WsSalesSolutionItem, WsSalesSolutionAction, WsSalesSolutionMetric } from '../core';
import { WsFilterOptions, getChildItems, getChildItemsFromTopLevelItems, getMetricAction } from '../helpers/item-helpers';




export type WsSalesSolutionActionListItem = {
  itemPath: string,
  path: string,
  action: WsSalesSolutionAction,
  index: number
};




const getActionListByAction = (itemPath: string, action: WsSalesSolutionAction, path: string, options: { filterSelected: boolean, includeChildActions: boolean }): WsSalesSolutionActionListItem[] => {
  const list: WsSalesSolutionActionListItem[] = [];


  // actions

  if (action.selected) {

    if (action.actions && Array.isArray(action.actions) && action.actions.length > 0) {

      action.actions.forEach((a: WsSalesSolutionAction, index: number) => {

        const actionPath = `${path}/${a.name}`;

        if (a.selected) {
          // TODO: a.selected
        }

        list.push({
          itemPath: itemPath,
          path: path,
          action: a,
          index
        });

        const actionList = getActionListByAction(itemPath, a, actionPath, options);
        list.push(...actionList);

      });
    }
  }


  // return

  return list;
};




const getActionListByItem = (item: WsSalesSolutionItem, itemPath: string, options: { filterSelected: boolean, includeChildActions: boolean }): WsSalesSolutionActionListItem[] => {
  const list: WsSalesSolutionActionListItem[] = [];


  // actions

  if (item.selected) {

    if (item.actions && Array.isArray(item.actions) && item.actions.length > 0) {

      item.actions.forEach((a: WsSalesSolutionAction, index: number) => {

        const actionPath = `${itemPath}/${a.name}`;

        if (a.selected) {
          // TODO: a.selected
        }

        list.push({
          path:     itemPath,
          itemPath: itemPath,
          action: a,
          index
        });

        const actionList = getActionListByAction(itemPath, a, actionPath, options);
        list.push(...actionList);

      });
    }
  }


  // return

  return list;
};




const getActionListByItemForFactors = (item: WsSalesSolutionItem, itemPath: string) => {
  const list: WsSalesSolutionActionListItem[] = [];


  // console.log(`item name : ${item.name}`);
  // console.log(`item itemPath : ${itemPath}`);

  const actionList = getActionListByItem(item, itemPath, { filterSelected: true, includeChildActions: true });

  actionList.forEach((actionListItem: WsSalesSolutionActionListItem) => {

    if (actionHasChildActions(actionListItem.action)) {
    } else {
      list.push(actionListItem);
    }
  });


  // return

  return list;
};















export type WsSalesSolutionActionFind = {
  action: WsSalesSolutionAction;
  parent: WsSalesSolutionItem | WsSalesSolutionAction | undefined;
  item:   WsSalesSolutionItem | undefined;
  path:   string;
};

const findActionById = (
  items:   WsSalesSolutionItem[]   | undefined,
  actions: WsSalesSolutionAction[] | undefined, 
  actionId: string,
  path: string,
  options: {
    filterSelected:      boolean, // TODO: should rename to filterSelectedItems
    includeChildActions: boolean  // TODO: not used
  },
  parent?: WsSalesSolutionItem | WsSalesSolutionAction

): WsSalesSolutionActionFind | undefined => {

  let findAction: WsSalesSolutionActionFind | undefined = undefined;


  // items
  if (items && Array.isArray(items) && items.length > 0) {

    items.forEach((item) => {

      const itemPath = `${path}/${item.name}`;

      let itemActions: WsSalesSolutionAction[] | undefined = undefined;
      if (options.filterSelected && item.selected || !options.filterSelected) {
        itemActions = item.actions;
      }

      const fa = findActionById(item.items, itemActions, actionId, itemPath, options, item);
      if (fa) {
        findAction = { ...fa };
        findAction.item = item;
      }

    });
  }


  // actions
  if (actions && Array.isArray(actions) && actions.length > 0) {

    actions.forEach((action) => {

      const actionPath = `${path}/${action.name}`;

      if (action.id === actionId) {

        findAction = {
          action: action,
          parent: parent,
          item:   undefined,
          path:   actionPath
        };

      } else {

        const fa = findActionById(undefined, action.actions, actionId, actionPath, options, action);
        if (fa) {
          findAction = fa;
        }
      }

    });
  }


  // return
  return findAction;
};














const getActionPath = (
  items: WsSalesSolutionItem[] | undefined,
  actionId: string,
  options: {
    filterSelected:      boolean, // TODO: should rename to filterSelectedItems
    includeChildActions: boolean  // TODO: not used
  }
) => {

  console.log('getActionPath');

  console.log(actionId);

  const findAction = findActionById(items, undefined, actionId, '', options);

  console.log(findAction);

  const originPath = findAction?.path.slice(1).replace(/\//g, ' / ');

  console.log(originPath);

  return originPath;
};




const getItemPath = (items: WsSalesSolutionItem[], itemType: string, item: any) => {

  const x = getChildItemsFromTopLevelItems(items, itemType, { includeChildCapabilities: true, includeChildActions: true });

  const y = x.find((a) => {
    if (a[0] && a[0].id === item.id) {
      return true;
    } else {
      return false;
    }
  });

  if (y && y[1]) {
    return `${y[2]}/${y[1].name}`.slice(1).replace(/\//g, ' / ');
  } else {
    return '';
  }
};








export type WsSalesSolutionItemFind = {
  item: WsSalesSolutionItem;
  parent: WsSalesSolutionItem | undefined;
  path: string;
};

const findItemById = (items: WsSalesSolutionItem[] | undefined, itemId: string, path: string, options: WsFilterOptions): WsSalesSolutionItemFind | undefined => {

  let value: WsSalesSolutionItemFind | undefined = undefined;

  if (items && Array.isArray(items) && items.length > 0) {

    items.forEach((item) => {

      if (item.id === itemId) {

        value = {
          parent: undefined,
          item,
          path
        };

      } else {

        const findItem = findItemById(item.items, itemId, `${path}/${item.name}`, options);

        if (findItem) {

          value = findItem;

          if (!value.parent) {
            value.parent = item;
          }
        }
      }
    });
  }  

  return value;
};









const actionHasChildActions = (action: WsSalesSolutionAction) => {
  if (action.actions && Array.isArray(action.actions) && action.actions.length > 0) {
    return true
  } else {
    return false;
  }
};




export {
  getActionListByAction,
  getActionListByItem,
  actionHasChildActions,
  getActionListByItemForFactors,
  findItemById,
  findActionById,
  getActionPath,
  getItemPath
};
